var _g, _rect, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPicture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.7915,
    y: 4.03833,
    width: 20.4615,
    height: 20.4615,
    fill: "#D0D3DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7915 25.7566L15.1109 14.4372C16.4427 13.1054 18.602 13.1054 19.9338 14.4372L31.2532 25.7566L17.5224 39.4874L3.7915 25.7566Z",
    fill: "#ACB3C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.10059 24.4177L6.9514 12.3657C8.28319 11.034 10.4424 11.034 11.7742 12.3657L23.8262 24.4177L9.36281 38.8811L-5.10059 24.4177Z",
    fill: "#8A929E"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.7402,
    y: 1.75,
    width: 3.17017,
    height: 10.5672,
    fill: "#697382"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16.0415,
    y: 8.61841,
    width: 3.17017,
    height: 10.5672,
    transform: "rotate(-90 16.0415 8.61841)",
    fill: "#697382"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.7915 8.12166C3.7915 5.8665 5.61967 4.03833 7.87484 4.03833H18.4197C21.6414 4.03833 24.253 6.65 24.253 9.87166V20.4165C24.253 22.6717 22.4249 24.4999 20.1697 24.4999H7.87484C5.61967 24.4999 3.7915 22.6717 3.7915 20.4165V8.12166Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.89af5aa9.svg";
export { ForwardRef as ReactComponent };